const stepSequence = [
    'lensType',
    'lensTypeVariant',
    'prescription',
    'prescriptionForm',
    'prescriptionUpload',
    'prescriptionValidation',
    'lensPackage',
    'lensAddOn',
    'lensAddOnVariant', 
];

export { stepSequence };
//# sourceMappingURL=index.js.map
